import { ctaType, fieldOfWorkType } from '@lib/proptypes';
import DetailHero from '@organisms/DetailHero/DetailHero';
import RelatedStoriesSection from '@organisms/RelatedStoriesSection/RelatedStoriesSection';
import Sections from '@organisms/Sections/Sections';
import useStoryDetail from '@utils/useStoryDetail';
import PropTypes from 'prop-types';

function StoryDetail({ page }) {
  const { relatedStories, hasRelatedStories } = useStoryDetail(page);
  const cta = {
    title: 'Bekijk alle verhalen',
    internalLink: [{ slug: '/verhalen' }],
  };

  return (
    <>
      <DetailHero
        title={page.title}
        text={page.text}
        image={page.image}
        imageAlt={page.imageAlt}
        date={page.publishOn}
        tags={page.fieldsOfWork}
        paddingBottom={!page?.sections?.length && !hasRelatedStories}
      />
      <Sections sections={page.sections} />
      {hasRelatedStories && (
        <RelatedStoriesSection
          title="Meer verhalen"
          relatedStories={relatedStories}
          cta={cta}
        />
      )}
    </>
  );
}

StoryDetail.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string.isRequired,
    publishDate: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string, typename: PropTypes.string })
    ),
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
      placeholder: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }).isRequired,
    imageAlt: PropTypes.string,
    publishOn: PropTypes.string,
    fieldsOfWork: PropTypes.arrayOf(fieldOfWorkType),
    cta: ctaType,
  }).isRequired,
};

export default StoryDetail;
